import { generateState } from '../builder'

export default {
  characterAges: [],
  ...generateState('getCharacterAges'),
}
